// extracted by mini-css-extract-plugin
module.exports = {"Padded":"Padded--uD1q1","Bordered":"Bordered--34HP5","HeaderWrapper":"HeaderWrapper--2vTs7"};